import { render, staticRenderFns } from "./OtherPayableList.vue?vue&type=template&id=3994c6c0&scoped=true&"
import script from "./OtherPayableList.vue?vue&type=script&lang=js&"
export * from "./OtherPayableList.vue?vue&type=script&lang=js&"
import style0 from "./OtherPayableList.vue?vue&type=style&index=0&id=3994c6c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3994c6c0",
  null
  
)

export default component.exports